<template lang="pug">
    .intro_timeline
        .it_arrow.top(@click="scroll('up')" data-hover)
        .it_wrapper
            .periods_list(ref="periods_list")
                .date(v-for="(date, ind) in periods"
                    :class="{active: activeDate===ind}"
                    @click="activeDate = ind"
                    data-hover
                    v-html="date.date")
        .it_arrow.bottom(@click="scroll('down')" data-hover)

</template>

<script>
    export default {
        name: "IntroTimeline",
        props:['periods', 'activePeriodId'],
        data:()=>({
            activeDate: 0, // index массива активного периода
            canScroll: true,
        }),
        watch:{
            activeDate(){
                this.$emit('changePeriod', this.periods[this.activeDate].id)
            }
        },
        methods:{
            scroll(dir){
                if (!this.canScroll) return
                this.canScroll = false
                setTimeout(()=>{
                    this.canScroll = true;
                },100);
                if (dir === 'down' && this.activeDate < this.periods.length-1){
                    this.activeDate++;
                } else if (dir === 'up' && this.activeDate > 0){
                    this.activeDate--;
                }
            }
        },
        mounted() {
            this.activeDate = this.periods.findIndex(el=>el.id == this.activePeriodId)
            this.$refs.periods_list.addEventListener('wheel', (e) => {
                let delta = e.deltaY;
                if (delta > 0) { // вниз
                    this.scroll('down');
                } else if (delta < 0) {
                    this.scroll('up');
                }
            })
        }
    }
</script>

<style scoped lang="scss">
    @import "@/assets/scss/_functions.scss";
    @import "@/assets/scss/_variables.scss";
.intro_timeline{
    position: absolute;
    top: 48.3%;
    right: 1.5vw;
    //z-index: -6;
    transform: translateY(-50%);

}
    .it_arrow{
        position: absolute;
        left: 50%;
        transform: translateX(-50%);
        width: to_rem(14px);
        height: to_rem(14px);
        background: url(../../assets/img/timeline_arrow.png) no-repeat center center / contain;
        cursor: pointer;
        &.top{
            bottom: 100%;
        }
        &.bottom{
            top: 100%;
            transform: scale(1, -1) translateX(-50%);
        }
    }
    .it_wrapper{
        position: relative;
        width: 13rem;
        padding: 0.5rem 0 1rem;
        overflow: hidden;
        &:after{
            content: '';
            display: block;
            position: absolute;
            left: 0;
            right: 0;
            bottom: 0;
            height: 30%;
            background: linear-gradient(to top, #fff 0%, rgba(255, 255, 255, 0.75) 25%, rgba(255, 255, 255, 0.25) 75%, rgba(255, 255, 255, 0) 100%);
            pointer-events: none;
        }
    }
    .periods_list{
        height: 100%;
        width: 100%;
        margin-right: 17px;
        overflow: hidden;

        .date{
            text-align: center;
            font-size: to_rem(15px);
            line-height: 1.5;
            color: #a7a7a7;
            cursor: pointer;
            transition: .15s linear;
            will-change: transform;
            transform: translate3d(0,0,0);
            &.active{
                color: $red;
                font-size: 2.5rem;
            }
        }
    }
</style>
